import { useId, useState } from 'react'
import BackButton from '../../../components/ui-components/BackButton'
import VaulDrawer from '../../../components/BottomSheetComponents/VaulDrawer'
import { goBack } from '../../../utils/appBridge'
import { getTopPadding } from '../../../utils/sessionStorage'
import { ELITE_PLANS_ELITE_PRIME_TAB_ID, useElitePlansLanding } from '../ElitePlansLandingContext'
import { ElitePlansEventId, trackElitePlansClick } from '../analytics'
import { ElitePrimeBackConfirmBottomSheet } from './ElitePrimeBackConfirmBottomSheet'
import { PlanSwitcher } from './PlanSwitcher'

export function ElitePlansHeader() {
  const { plans, selectedPlanId, setSelectedPlanId, tabPanelId } = useElitePlansLanding()
  const [isPrimeBackSheetOpen, setIsPrimeBackSheetOpen] = useState(false)
  const titleId = useId()
  const isElitePrimeTab = selectedPlanId === ELITE_PLANS_ELITE_PRIME_TAB_ID

  const handleBack = () => {
    trackElitePlansClick(ElitePlansEventId.Back)
    // Prime tab: confirm before leaving — pop only from the sheet’s Go back
    if (isElitePrimeTab) {
      setIsPrimeBackSheetOpen(true)
      return
    }
    goBack()
  }

  return (
    <>
      <header
        style={{ paddingTop: `${getTopPadding()}px` }}
        className='ep-hero-zone sticky top-0 z-30 flex items-center border-b border-b-[color:var(--ep-header-border)] bg-[color:var(--ep-bg-top)] px-3 text-[color:var(--ep-header-ink)]'
      >
        <div className='flex h-11 w-11 shrink-0 items-center justify-center'>
          <BackButton fill='currentColor' size={24} onClick={handleBack} aria-label='Back' />
        </div>
        <div className='flex flex-1 justify-center pr-11'>
          <PlanSwitcher
            plans={plans}
            selectedPlanId={selectedPlanId}
            onPlanChange={setSelectedPlanId}
            tabPanelId={tabPanelId}
          />
        </div>
      </header>

      <VaulDrawer
        open={isPrimeBackSheetOpen}
        setOpen={setIsPrimeBackSheetOpen}
        titleId={titleId}
        focusDrawerOnOpen
      >
        <ElitePrimeBackConfirmBottomSheet
          titleId={titleId}
          onClose={() => setIsPrimeBackSheetOpen(false)}
        />
      </VaulDrawer>
    </>
  )
}
